const stabilityColumns = {
  orderId: {
    key: 'sample.orderId',
    label: 'orderId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  sampleCode: {
    key: 'sampleId',
    label: 'customerSampleId',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  name: {
    key: 'name',
    label: 'stability.name',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  customer: {
    key: 'sample.order.customer.name',
    label: 'customer',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  docNumber: {
    key: 'offerDocNumber',
    label: 'stability.docNumber',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  productName: {
    key: 'sample.productName',
    label: 'stability.productName',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  analysisCode: {
    key: 'analysis.code',
    label: 'stability.analysisCode',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  analysisDescription: {
    key: 'analysis.description',
    label: 'stability.analysisDescription',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  status: {
    key: 'status',
    label: 'status',
    type: 'tag',
    tagType: (row) => {
      const map = {
        pending: 'warning',
        processing: 'info',
        configured: 'success',
        error: 'danger',
      };
      return map[row.status] || '';
    },
    translated: true,
    getLabel: (row) => `enums.stabilityStatus.${row.status}`,
    sortable: false,
    minWidth: 150,
  },
  createdAt: {
    key: 'createdAt',
    label: 'stability.createdAt',
    type: 'datetime',
    sortable: 'custom',
    minWidth: 170,
  },
  configuredAt: {
    key: 'configuredAt',
    label: 'stability.configuredAt',
    type: 'datetime',
    sortable: 'custom',
    minWidth: 170,
  },
  configuredBy: {
    key: 'configuredByUser.username',
    label: 'stability.configuredBy',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  timePoints: {
    key: 'stabilityTimePoints',
    label: 'stability.timePoints',
    type: 'function',
    get: (value) => (value ? value.length : 0),
    sortable: false,
    minWidth: 120,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 130,
    buttons: [
      {
        name: (row) => (row.status === 'pending' ? 'configure' : 'show'),
        icon: 'fas fa-cog',
        secondaryIcon: (row) =>
          row.status === 'pending' ? 'fas fa-cog' : 'fas fa-eye',
        permissions: ['stabilityConfigView'],
      },
      {
        name: 'retry',
        icon: 'fas fa-redo',
        permissions: ['stabilityConfigManage'],
        showCondition: (row) => row.status === 'error',
      },
    ],
  },
};

export default stabilityColumns;
